<template>
    <v-container class="pa-5" fluid>
        <SaveProductionProcessDialog
            :is-open="saveProductionProcessDialog"
            :production-process="productionProcess"
            :product-production-property-values="productProductionPropertyValues"
            :steps="steps"
            @on-save="saveProductionProcess"
            @on-close="closeProductionProcessDialog"
        />

        <page-title>Procesy Produkcyjne</page-title>

        <v-row align="center">
            <v-col cols="12" sm="6" lg="4">
                <v-btn
                    color="secondary"
                    medium
                    data-sentry-label="Dodaj proces produkcyjny"
                    @click="showProductionProcessDialog"
                >
                    <v-icon left>
                        mdi-plus
                    </v-icon>
                    Dodaj proces produkcyjny
                </v-btn>
            </v-col>
            <v-col cols="12" sm="6" lg="8">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="8" md="6" lg="4" xl="3">
                            <v-text-field
                                v-model="filters.name"
                                append-icon="mdi-magnify"
                                label="Nazwa..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('name')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="productionProcesses"
                        :loading="productionProcessesLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="productionProcessesData"
                        @pagination="updatePagination"
                    >
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Edytuj"
                                            v-on="on"
                                            @click="showEditProductionProcessDialog(item.id)"
                                        >
                                            <v-icon color="teal">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Edytuj</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import SaveProductionProcessDialog from './SaveProductionProcessDialog'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
import { isEmpty } from 'lodash'

export default {
    name: 'ProductProductionProcesses',
    components: {
        PageTitle, SaveProductionProcessDialog
    },
    mixins: [
        filters,
        pagination,
        tooltipDelay
    ],
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('configurations/clearProductProductionProcessesFilters')
        next()
    },
    data() {
        return {
            productionProcess: {},
            productProductionPropertyValues: [],
            saveProductionProcessDialog: false,
            steps: [],
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        productionProcesses() {
            return this.$store.state.configurations.productProductionProcesses.productionProcesses
        },
        productionProcessesLoading() {
            return this.$store.state.configurations.productProductionProcesses.productionProcessesLoading
        },
        savedFilters() {
            return this.$store.state.configurations.productProductionProcesses.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && filters[item] !== '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    mounted() {
        this.getProductionProcesses(),
        this.$store.dispatch('configurations/getProductProductionPropertyValues')
            .then(response => {
                this.productProductionPropertyValues = response.data
            })
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        isNewProductionProcess() {
            return isEmpty(this.productionProcess)
        },
        getProductionProcesses() {
            this.$store.dispatch('configurations/getProductionProcesses', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showProductionProcessDialog() {
            this.saveProductionProcessDialog = true
        },
        showEditProductionProcessDialog(productionProcessId) {
            Promise.all([
                this.$store.dispatch('configurations/getProductionProcess', productionProcessId),
                this.$store.dispatch('configurations/getSteps')
            ])
                .then(responses => {
                    this.productionProcess = responses[0].data
                    this.steps = responses[1].data.results
                    this.saveProductionProcessDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeProductionProcessDialog() {
            this.saveProductionProcessDialog = false

            setTimeout(() => {
                this.productionProcess = {}
            }, 500)
        },
        saveProductionProcess() {
            this.saveProductionProcessDialog = false
            this.getProductionProcesses()
            this.closeProductionProcessDialog()
        },
        changeFilter() {
            this.$store.dispatch('configurations/setProductProductionProcessesFilters', this.filters)
            this.resetPagination()
            this.getProductionProcesses()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getProductionProcesses()
            }
            this.clearPaginationPending()
        }
    }
}
</script>
